import { useNavigate, useSearchParams } from 'react-router-dom'

import { GenufitAuthBrand } from './GenufitAuthBrand'

function SignupSuccess() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const email = searchParams.get('email') || ''

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-subtle px-4" data-testid="signup-success-page">
      <div className="flex w-full max-w-[400px] flex-col items-center gap-8">
        <GenufitAuthBrand />

        <div className="w-full rounded-lg bg-surface-default p-8 shadow-sm text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-brand-primary-subtle mb-6">
            <svg className="h-8 w-8 text-brand-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>

          <h2 className="text-h2 font-semibold text-text-primary mb-3">Check your email</h2>

          <div className="space-y-4 mb-6">
            <p className="text-body text-text-secondary leading-relaxed">
              We&apos;ve sent a confirmation email to <strong className="text-text-primary">{email}</strong>
            </p>
            <p className="text-body text-text-secondary leading-relaxed">
              Please click the confirmation link in the email to verify your email address and complete your registration.
            </p>
            <div className="bg-interactive-subtle border border-border-default rounded-lg p-4 mt-4 text-left">
              <p className="text-small text-text-secondary font-medium mb-2">Didn&apos;t receive the email?</p>
              <ul className="text-small text-text-secondary space-y-1 list-disc list-inside">
                <li>Check your spam or junk folder</li>
                <li>Make sure you entered the correct email address</li>
                <li>Wait a few minutes and check again</li>
              </ul>
            </div>
          </div>

          <div className="space-y-3">
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="w-full min-h-11 px-4 py-2.5 text-small font-medium text-text-primary bg-surface-muted rounded-md hover:bg-surface-subtle transition-colors"
            >
              Back to sign in
            </button>
            <p className="text-small text-text-muted">
              Once you&apos;ve confirmed your email, you can sign in to continue.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignupSuccess
